// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/user_administration.proto (package com.americanexpress.dining.user.admin.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ResyUser } from "../resy/user_pb";
import { file_resy_user } from "../resy/user_pb";
import type { TockPatron } from "../tock/patron_pb";
import { file_tock_patron } from "../tock/patron_pb";
import type { GdusUser } from "./gdus_user_pb";
import { file_user_gdus_user } from "./gdus_user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/user_administration.proto.
 */
export const file_user_user_administration: GenFile = /*@__PURE__*/
  fileDesc("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", [file_resy_user, file_tock_patron, file_user_gdus_user]);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginRequest
 */
export type InsertUserIdentityForcedReloginRequest = Message<"com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginRequest.
 * Use `create(InsertUserIdentityForcedReloginRequestSchema)` to create a new message.
 */
export const InsertUserIdentityForcedReloginRequestSchema: GenMessage<InsertUserIdentityForcedReloginRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 0);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginResponse
 */
export type InsertUserIdentityForcedReloginResponse = Message<"com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginResponse"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.InsertUserIdentityForcedReloginResponse.
 * Use `create(InsertUserIdentityForcedReloginResponseSchema)` to create a new message.
 */
export const InsertUserIdentityForcedReloginResponseSchema: GenMessage<InsertUserIdentityForcedReloginResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 1);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ActivateUsersRequest
 */
export type ActivateUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.ActivateUsersRequest"> & {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ActivateUsersRequest.
 * Use `create(ActivateUsersRequestSchema)` to create a new message.
 */
export const ActivateUsersRequestSchema: GenMessage<ActivateUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 2);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.ActivateUsersResponse
 */
export type ActivateUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.ActivateUsersResponse"> & {
  /**
   * @generated from field: repeated string not_found_uuids = 1;
   */
  notFoundUuids: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.ActivateUsersResponse.
 * Use `create(ActivateUsersResponseSchema)` to create a new message.
 */
export const ActivateUsersResponseSchema: GenMessage<ActivateUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 3);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest
 */
export type DeactivateUsersRequest = Message<"com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest"> & {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeactivateUsersRequest.
 * Use `create(DeactivateUsersRequestSchema)` to create a new message.
 */
export const DeactivateUsersRequestSchema: GenMessage<DeactivateUsersRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 4);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse
 */
export type DeactivateUsersResponse = Message<"com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse"> & {
  /**
   * UUIDs from the request that did not match any GDUS user — skipped without error.
   *
   * @generated from field: repeated string not_found_uuids = 1;
   */
  notFoundUuids: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.DeactivateUsersResponse.
 * Use `create(DeactivateUsersResponseSchema)` to create a new message.
 */
export const DeactivateUsersResponseSchema: GenMessage<DeactivateUsersResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 5);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: repeated string concierge_group_names = 2;
   */
  conciergeGroupNames: string[];
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 6);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserResponse"> & {
  /**
   * @generated from oneof com.americanexpress.dining.user.admin.proto.UpdateUserResponse.response
   */
  response: {
    /**
     * @generated from field: com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse success_response = 1;
     */
    value: UpdateUserSuccessResponse;
    case: "successResponse";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse error_response = 2;
     */
    value: UpdateUserErrorResponse;
    case: "errorResponse";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 7);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse
 */
export type UpdateUserSuccessResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserSuccessResponse.
 * Use `create(UpdateUserSuccessResponseSchema)` to create a new message.
 */
export const UpdateUserSuccessResponseSchema: GenMessage<UpdateUserSuccessResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 8);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse
 */
export type UpdateUserErrorResponse = Message<"com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse"> & {
  /**
   * @generated from field: string error = 1;
   */
  error: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UpdateUserErrorResponse.
 * Use `create(UpdateUserErrorResponseSchema)` to create a new message.
 */
export const UpdateUserErrorResponseSchema: GenMessage<UpdateUserErrorResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 9);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UserSearchRequest
 */
export type UserSearchRequest = Message<"com.americanexpress.dining.user.admin.proto.UserSearchRequest"> & {
  /**
   * @generated from oneof com.americanexpress.dining.user.admin.proto.UserSearchRequest.search_type
   */
  searchType: {
    /**
     * @generated from field: string gdus_uuid = 1;
     */
    value: string;
    case: "gdusUuid";
  } | {
    /**
     * @generated from field: string email_address = 2;
     */
    value: string;
    case: "emailAddress";
  } | {
    /**
     * @generated from field: string phone_number = 3;
     */
    value: string;
    case: "phoneNumber";
  } | {
    /**
     * Tried against both Resy and Tock numeric IDs; may return up to two users.
     *
     * @generated from field: uint64 numeric_user_id = 4;
     */
    value: bigint;
    case: "numericUserId";
  } | {
    /**
     * wildcard name/email search
     *
     * @generated from field: string text = 5;
     */
    value: string;
    case: "text";
  } | { case: undefined; value?: undefined };

  /**
   * 0-indexed page number, defaults to 0
   *
   * @generated from field: optional int32 page = 6;
   */
  page?: number;

  /**
   * results per page, defaults to and capped at 25
   *
   * @generated from field: optional int32 page_size = 7;
   */
  pageSize?: number;

  /**
   * When false (default), Resy and Tock profile enrichment is skipped; only GDUS identity fields
   * are returned. Set to true for detail views where the full profile is needed.
   *
   * @generated from field: optional bool include_profiles = 8;
   */
  includeProfiles?: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UserSearchRequest.
 * Use `create(UserSearchRequestSchema)` to create a new message.
 */
export const UserSearchRequestSchema: GenMessage<UserSearchRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 10);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.User
 */
export type User = Message<"com.americanexpress.dining.user.admin.proto.User"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.user.proto.GdusUser gdus_user = 1;
   */
  gdusUser?: GdusUser;

  /**
   * @generated from field: optional com.americanexpress.dining.resy.proto.ResyUser resy_user = 2;
   */
  resyUser?: ResyUser;

  /**
   * @generated from field: optional com.americanexpress.dining.tock.proto.TockPatron tock_patron = 3;
   */
  tockPatron?: TockPatron;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 11);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.UserSearchResponse
 */
export type UserSearchResponse = Message<"com.americanexpress.dining.user.admin.proto.UserSearchResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.user.admin.proto.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.UserSearchResponse.
 * Use `create(UserSearchResponseSchema)` to create a new message.
 */
export const UserSearchResponseSchema: GenMessage<UserSearchResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 12);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.SyncUserRequest
 */
export type SyncUserRequest = Message<"com.americanexpress.dining.user.admin.proto.SyncUserRequest"> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.SyncUserRequest.
 * Use `create(SyncUserRequestSchema)` to create a new message.
 */
export const SyncUserRequestSchema: GenMessage<SyncUserRequest> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 13);

/**
 * @generated from message com.americanexpress.dining.user.admin.proto.SyncUserResponse
 */
export type SyncUserResponse = Message<"com.americanexpress.dining.user.admin.proto.SyncUserResponse"> & {
};

/**
 * Describes the message com.americanexpress.dining.user.admin.proto.SyncUserResponse.
 * Use `create(SyncUserResponseSchema)` to create a new message.
 */
export const SyncUserResponseSchema: GenMessage<SyncUserResponse> = /*@__PURE__*/
  messageDesc(file_user_user_administration, 14);

/**
 * @generated from service com.americanexpress.dining.user.admin.proto.UserAdministrationService
 */
export const UserAdministrationService: GenService<{
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.InsertUserIdentityForcedRelogin
   */
  insertUserIdentityForcedRelogin: {
    methodKind: "unary";
    input: typeof InsertUserIdentityForcedReloginRequestSchema;
    output: typeof InsertUserIdentityForcedReloginResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.ActivateUsers
   */
  activateUsers: {
    methodKind: "unary";
    input: typeof ActivateUsersRequestSchema;
    output: typeof ActivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.DeactivateUsers
   */
  deactivateUsers: {
    methodKind: "unary";
    input: typeof DeactivateUsersRequestSchema;
    output: typeof DeactivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.UserSearch
   */
  userSearch: {
    methodKind: "unary";
    input: typeof UserSearchRequestSchema;
    output: typeof UserSearchResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.user.admin.proto.UserAdministrationService.SyncUser
   */
  syncUser: {
    methodKind: "unary";
    input: typeof SyncUserRequestSchema;
    output: typeof SyncUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_user_administration, 0);

